export const RiskTolerance = [
  'high',
  'medium',
  'low'
];
